export default "__VITE_ASSET__Fi1sa_cd__"